import { MODEL_FIELDS } from './confirmWarrant.model';

export const DATA_GENERATOR_CONFIG = (countryCode) => [
  { name: MODEL_FIELDS.firstName, type: 'text' },
  { name: MODEL_FIELDS.lastName, type: 'text' },
  { name: MODEL_FIELDS.oldIban, type: 'text', validate: 'iban', countryCode },
  { name: MODEL_FIELDS.newIban, type: 'text', validate: 'iban', countryCode },
];
